import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, AfterViewInit } from '@angular/core';
import * as L from 'leaflet';
import 'leaflet-routing-machine';
import 'leaflet-polylinedecorator';
import { ICoordinates } from './map-leaflet.interface';

@Component({
  selector: 'app-map-leaflet',
  templateUrl: './map-leaflet.component.html',
  styleUrls: ['./map-leaflet.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MapLeafletComponent implements OnChanges, AfterViewInit {
  @Input() mapobjectid: string;
  @Input() markers: ICoordinates[];
  @Output() returnPosition = new EventEmitter();
  @Input() drag: boolean;
  @Input() geolocation: boolean;
  @Input() eventClick: boolean;
  @Input() routingPointsinMap: boolean;
  @Input() routingLineinMap: boolean;
  @Input() notUpdate: boolean;

  public IdMapPublic: string;

  private ObjectLocation: ICoordinates;

  public map;

  private marker;

  private iconAsset: string;

  private mult: boolean;

  private initMap(): void {
    /** */
  }

  private markersaveArray;

  constructor() {
    this.IdMapPublic = this.mapobjectid;
    this.drag = false;
    this.eventClick = false;
    this.geolocation = false;
    this.iconAsset = '../../../../../../../assets/images/service/map/ic-pin-recogida.png';
    this.ObjectLocation = {
      latitude: 4.6482837,
      longitude: -74.2478913,
      ico: this.iconAsset,
    };
    this.routingLineinMap = false;
    this.markersaveArray = [];
    this.notUpdate = false;
  }

  GetIdMap(): string {
    return this.IdMapPublic;
  }

  initAddMap() {
    this.map = L.map(this.IdMapPublic, {
      center: [this.ObjectLocation.longitude, this.ObjectLocation.latitude],
      zoom: 13,
    });
    const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    });
    tiles.addTo(this.map);
  }

  getLocation(): void {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        this.ObjectLocation.longitude = position.coords.longitude;
        this.ObjectLocation.latitude = position.coords.latitude;
        this.ObjectLocation.ico = this.iconAsset;
        this.updateMap(this.ObjectLocation, this.map);
        this.includeMarkerDrag(this.ObjectLocation);
      });
    }
  }

  updateMap(position, map): void {
    map.setView([position.latitude, position.longitude], 14);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.hasOwnProperty('mapobjectid')) {
      if (this.IdMapPublic !== changes.mapobjectid.currentValue) {
        this.IdMapPublic = changes.mapobjectid.currentValue;
        this.initAddMap();
      } else {
        if (!this.map) {
          this.initAddMap();
        }
      }
    }

    if (changes.hasOwnProperty('markers')) {
      this.markers = changes.markers.currentValue;
      if (this.markers.length > 0) {
        this.updateMap(this.markers[0], this.map);
      } else {
        this.updateMap(this.ObjectLocation, this.map);
      }
    }

    if (changes.hasOwnProperty('notUpdate')) {
      this.notUpdate = changes.notUpdate.currentValue;
    }

    this.ngOnChangesRoundTrip();

    if (this.eventClick) {
      this.handleClick();
    }

    if (this.routingLineinMap) {
      this.drawLineinMap();
    }
  }

  ngOnChangesRoundTrip(): void {
    if (this.routingPointsinMap && Object.keys(this.markers).length > 0) {
      this.routingPoints(this.markers);
    } else {
      if (!this.notUpdate && this.markersaveArray.length > 0) {
        this.markersaveArray.map(item => {
          return item.remove();
        });
        this.markersaveArray = [];
      }
      Object.keys(this.markers).forEach((item, index) => {
        if (this.drag && !this.routingLineinMap) {
          this.includeMarkerDrag(this.markers[item]);
        } else {
          this.includeMarker(this.markers[item]);
        }
      });
    }
  }

  ngAfterViewInit() {
    if (!this.map) {
      this.initAddMap();
    }
    if (this.geolocation) {
      this.getLocation();
    }
  }

  generateIcon(nameIconImage, html = '') {
    let greenIcon;
    if (html.length === 0) {
      greenIcon = L.icon({
        iconUrl: `${nameIconImage}`,
        iconSize: [28, 36], // size of the icon
        iconAnchor: [13, 32], // point of the icon which will correspond to marker's location
        popupAnchor: [2, -34], // point from which the popup should open relative to the iconAnchor
      });
    } else {
      greenIcon = L.divIcon({
        className: `number-icon`,
        iconSize: [28, 36], // size of the icon
        iconAnchor: [13, 32], // point of the icon which will correspond to marker's location
        popupAnchor: [2, -34], // point from which the popup should open relative to the iconAnchor
        html: `<div style="background-image:url('${nameIconImage}');">${html}<div>`,
      });
    }
    return greenIcon;
  }

  includeMarker(objectLatitude) {
    let markerArray = [];
    markerArray = this.markersaveArray;

    if (!objectLatitude.hasOwnProperty('html')) {
      objectLatitude.html = '';
    }
    const markerInit = L.marker([objectLatitude.latitude, objectLatitude.longitude], {
      icon: this.generateIcon(objectLatitude.ico, objectLatitude.html),
    });
    if (objectLatitude.hasOwnProperty('msn') && !objectLatitude.hasOwnProperty('open') && !objectLatitude.open) {
      markerInit.bindPopup(`${objectLatitude.msn}`).openPopup();
    }

    if (objectLatitude.hasOwnProperty('msn') && objectLatitude.hasOwnProperty('open') && objectLatitude.open) {
      markerInit.bindPopup(`${objectLatitude.msn}`).openPopup();
    }
    markerArray.push(markerInit);
    this.markersaveArray.push(markerInit);
    const group = L.featureGroup(markerArray).addTo(this.map);
    this.map.fitBounds(group.getBounds());
  }

  includeMarkerDrag(objectLatitude) {
    if (!objectLatitude.hasOwnProperty('html')) {
      objectLatitude.html = '';
    }

    const markerInit = L.marker([objectLatitude.latitude, objectLatitude.longitude], {
      icon: this.generateIcon(objectLatitude.ico, objectLatitude.html),
      draggable: true,
    });

    if (objectLatitude.hasOwnProperty('msn') && !objectLatitude.hasOwnProperty('open') && !objectLatitude.open) {
      markerInit.bindPopup(`${objectLatitude.msn}`);
    }

    if (objectLatitude.hasOwnProperty('msn') && objectLatitude.hasOwnProperty('open') && objectLatitude.open) {
      markerInit.bindPopup(`${objectLatitude.msn}`).openPopup();
    }

    this.markersaveArray.push(markerInit);
    this.marker = markerInit.addTo(this.map).on('dragend', e => {
      const coord = String(e.target.getLatLng()).split(',');
      const lati = coord[0].split('(');
      const long = coord[1].split(')');
      const msnReturn = `${objectLatitude.msn ? objectLatitude.msn : ''} </br> Moved to: ${lati[1]} , ${long[0]} .`;
      const jsondata = JSON.stringify({ latitude: lati[1], longitude: long[0], ico: '', msn: msnReturn, open: true });
      this.returnPosition.emit(jsondata);
    });

    if (this.routingLineinMap) {
      this.drawLineinMap();
    }
  }

  handleClick() {
    this.map.on('click', e => {
      const coord = e.latlng.toString().split(',');
      const lati = coord[0].split('(');
      const long = coord[1].split(')');
      const jsondata = JSON.stringify({ latitude: lati[1], longitude: long[0], ico: '' });
      this.ObjectLocation.longitude = long[0];
      this.ObjectLocation.latitude = lati[1];
      this.ObjectLocation.ico = this.iconAsset;
      if (!this.notUpdate && this.markersaveArray.length > 0) {
        this.markersaveArray.map(item => {
          return item.remove();
        });
        this.markersaveArray = [];
      }
      this.includeMarkerDrag(this.ObjectLocation);
      this.returnPosition.emit(jsondata);
    });
  }

  routingPoints(markers) {
    const waypointsObject = [];
    Object.keys(markers).forEach((item, index) => {
      waypointsObject.push(L.latLng(markers[item].latitude, markers[item].longitude));
    });
    L.Routing.control({
      waypoints: waypointsObject,
      routeWhileDragging: true,
    }).addTo(this.map);
  }

  drawLineinMap() {
    const latlngs = [];
    Object.keys(this.markers).forEach((item, index) => {
      latlngs.push([this.markers[item].latitude, this.markers[item].longitude]);
    });
    this.drawLine(latlngs);
  }

  drawLine(objectLatitude) {
    const polyline = L.polyline(objectLatitude, { color: '#1d3242' }).addTo(this.map);
    L.polylineDecorator(polyline, {
      patterns: [
        {
          offset: 25,
          repeat: 50,
          symbol: L.Symbol.arrowHead({ pixelSize: 15, pathOptions: { color: '#517fa4', fillOpacity: 1, weight: 0 } }),
        },
      ],
    }).addTo(this.map);
    this.map.fitBounds(polyline.getBounds());
  }
}
